import NetAiLogo from '../../Assets/netai-logo.png'
import BluexkyeLogo from '../../Assets/bluexkye-logo.jpg'

export const experiences = [
  {
    id: 1,
    role: "Software Engineer (Frontend)",
    company: "NetAI Inc.",
    location: "Ahmedabad, Gujarat (Office)",
    duration: "May 2025 - Present",
    type: "Full-time",
    description:
      "Working in the frontend team to build optimized, scalable, and reusable components for enterprise applications. Developing Higher-Order Components and implementing state management using Zustand.",
    achievements: [
      "Built interactive World Map Visualization Network Topology with real-time alert detection, reducing incident investigation time by approximately 30%",
      "Designed and developed a Software License Request and Management Dashboard, enabling sales requests, approval flow, and license visibility, reducing manual coordination delays",
      "Implemented Role-Based Access Control (RBAC) to securely manage permissions across multiple user roles",
      "Integrated gRPC APIs and optimized Next.js components, improving application load times by 20%",
    ],
    technologies: ["Next.js", "Tailwind CSS", "Zustand", "React", "TypeScript"],
    companyImage: NetAiLogo,
    colorClass: "gradient-purple",
  },
  {
    id: 2,
    role: "Full Stack Developer Intern",
    company: "Bluexkye",
    location: "Ahmedabad, Gujarat (Office)",
    duration: "Feb 2025 - May 2025",
    type: "Internship",
    description:
      "Worked on the 'Crick Prediction App' project as a full-stack developer. Developed backend APIs with Node.js, Express, and Sequelize, and integrated PostgreSQL. Designed flow diagrams for project presentation and contributed to front-end using React.",
    achievements: [
      "Built full-stack MVP of Crick Prediction App with React + PostgreSQL",
      "Implemented database migrations using sequelize-cli",
      "Created visual flow diagrams for team presentation",
    ],
    technologies: ["React", "Node.js", "Express", "Sequelize", "PostgreSQL"],
    companyImage: BluexkyeLogo,
    colorClass: "gradient-blue",
  },
];